module.exports = __webpack_public_path__ + "static/media/BANNER - card payment_V6.29e37c55.jpg";